"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoIconOrange;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InfoIconOrange(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C5.61615 2 2 6.48618 2 11C2 15.5138 5.61615 20 11 20C16.3839 20 20 15.5138 20 11C20 6.48618 16.3839 2 11 2ZM0 11C0 5.51382 4.38385 0 11 0C17.6161 0 22 5.51382 22 11C22 16.4862 17.6161 22 11 22C4.38385 22 0 16.4862 0 11Z",
    fill: "#DB7C0F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 5C11.5523 5 12 5.44772 12 6V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V6C10 5.44772 10.4477 5 11 5Z",
    fill: "#DB7C0F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16Z",
    fill: "#DB7C0F"
  }));
}